/**
 * MKS-532 — frontend transport for the comment-audience read:
 *
 *   GET /api/projects/:projectId/comment-audience
 *   →   { data: { hasExternalCollaborators: boolean } }
 *
 * Internal actors only (the endpoint is behind `authenticate`); the portal's
 * reply composer never calls it.
 */
import { apiGet } from './client';

export interface CommentAudience {
  hasExternalCollaborators: boolean;
}

interface CommentAudienceResponse {
  data: CommentAudience;
}

export async function fetchCommentAudience(
  projectId: number,
): Promise<CommentAudience> {
  const res = await apiGet<CommentAudienceResponse>(
    `/projects/${projectId}/comment-audience`,
  );
  return res.data;
}
